<div class="layout-switcher-container">
  <button mat-icon-button
          class="layout-menu-trigger"
          [matMenuTriggerFor]="isMobileView ? null : layoutMenu"
          [matTooltip]="isMobileView ? 'Toggle navigation panel' : getActiveTooltip()"
          (click)="isMobileView ? selectLayout('toggle_mobile_nav') : null">
    <mat-icon>{{ getActiveIcon() }}</mat-icon>
  </button>

  <!-- Search button - only show when hideSearch is false -->
  <button *ngIf="!hideSearch"
          mat-icon-button
          class="search-button"
          (click)="toggleSearch()"
          matTooltip="Search subjects">
    <mat-icon>search</mat-icon>
  </button>

  <!-- Search input - only show when showSearch is true and hideSearch is false -->
  <div class="search-container" *ngIf="showSearch && !hideSearch">
    <input #searchInput type="text" class="search-input"
           placeholder="Search in English or Hindi..."
           [(ngModel)]="searchTerm"
           (keyup)="onSearchKeyUp($event)"
           (keyup.enter)="performSearch()"
           matTooltip="Search in both English and Hindi text">
    <button mat-icon-button class="clear-search" *ngIf="searchTerm" (click)="clearSearch()" matTooltip="Clear search">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- These buttons should be outside the search container but only visible when search is shown and hideSearch is false -->
  <ng-container *ngIf="showSearch && !hideSearch">
    <button mat-icon-button class="filter-toggle"
            [class.active-filter]="filterMode"
            (click)="toggleFilterMode()"
            [matTooltip]="filterMode ? 'Show all nodes' : 'Show only matching nodes'">
      <mat-icon>filter_list</mat-icon>
    </button>
    <button mat-icon-button
            class="search-now-button"
            (click)="performSearch()"
            matTooltip="Search now"
            color="primary">
      <mat-icon>search</mat-icon>
    </button>
  </ng-container>

  <mat-menu #layoutMenu="matMenu" class="layout-options-menu">
    <div class="layout-menu-title">Select Layout</div>
    <div class="layout-options-container">
      <button mat-menu-item
              *ngFor="let option of layoutOptions"
              (click)="selectLayout(option.id)"
              [class.active-layout]="currentLayout === option.id">
        <mat-icon>{{ option.icon }}</mat-icon>
        <span>{{ option.label }}</span>
      </button>
    </div>
  </mat-menu>
</div>
